import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';;


@Component({
  selector: 'iho-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatRippleModule,
    RouterModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideMenuComponent {
  // @Input() isOpen: boolean = false;
  _isOpen = false
  isShow = false
  cdnUrl = cdnUrl
  
  private renderer = inject(Renderer2)
  @Output() toggleDrawer = new EventEmitter()
  @ViewChild('backdrop', { static: false }) backdrop!: ElementRef

  @Input('isOpen') set isOpen(value: boolean) {

    if (value == true) {
      this.toggleNav();
    }
  }


  toggleNav() {
    this.isShow = !this.isShow;

    if (this.isShow) {
      this.createRecaptchaContainer();
      this.renderer.selectRootElement("#backdrop", true).addEventListener('click', this.onClickRemoveSide.bind(this));



    } else {
      this.renderer.selectRootElement("#backdrop").remove();
      this.renderer.removeClass(document.body, 'side-open');
      this._isOpen = !this._isOpen;
      this.toggleDrawer.emit(false);
    }
  }

  createRecaptchaContainer() {
    const backDrop = this.renderer.createElement('div');

    this.renderer.addClass(document.body, 'side-open');


    this.renderer.setProperty(backDrop, 'id', 'backdrop');

    this.renderer.appendChild(document.body, backDrop);

    return backDrop;
  }

  onClickRemoveSide() {
    this.renderer.selectRootElement("#backdrop").remove();
    this.renderer.removeClass(document.body, 'side-open');
    this.isShow = !this.isShow;
    this.toggleDrawer.emit(false);
  }
}
